import React from "react";
import {Images} from "../controller/Images";
import {login, setUserToken} from "../controller/AuthService";
import history from '../controller/History';

export class Login extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      email: '',
      password: '',
      submitted: false
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleChange(e) {
    const {name, value} = e.target;
    this.setState({[name]: value});
  }

  handleSubmit(e) {
    e.preventDefault();
    this.setState({submitted: true});
    const {email, password} = this.state;
    if (email && password) {
      login(email, password)
        .then(response => {
          setUserToken(response.token);
          history.push('/dashboard/')
        });
    }
  }

  render() {
    const {email, password, submitted} = this.state;
    return (
      <div className="container-fluid paddingZ login-section">
        <div className="login-div card floating-form">
          <div className="card-header">
            <img className="img-fluid logo" alt="Logo" src={Images.image_logo}/>
          </div>
          <form onSubmit={this.handleSubmit} method="post">
            <div className={'floating-label' + (submitted && !email ? ' has-error' : '')}>
              <input id="id_email" name="email" className="floating-input" type="email" value={email} placeholder=" "
                     onChange={this.handleChange} aria-label="Email"/>
              <label>Email</label>
              {submitted && !email && <div className="help-block">Email is required.</div>}
            </div>

            <div className={'floating-label' + (submitted && !password ? ' has-error' : '')}>
              <input id="id_password" name="password" className="floating-input" type="password" placeholder=" "
                     value={password} onChange={this.handleChange} aria-label="Password"/>
              <label>Password</label>
              {submitted && !password && <div className="help-block">Password is required.</div>}
            </div>
            <div className="text-center">
              <input id="loginform-btn" className="trans btn submit-btn" type="submit" value="Login"/>
            </div>
          </form>
        </div>
      </div>

    )
  }
}




// WEBPACK FOOTER //
// ./src/pages/Login.jsx